/**
 * Known non-actionable browser noise, cross-origin script redactions,
 * and extension errors that pollute logs and error tracking.
 */
export const IGNORED_ERROR_PATTERNS: readonly string[] = [
  'Script error.',
  'Script error',
  'Javascript error: Script error on line 0',
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.',
  '__alhWeb',
  '__firefox__',
  'EmptyRanges',
  'fetching process for the media resource was aborted',
  'The fetching process for the media resource was aborted',
]

/**
 * Returns true if the provided error message matches any known non-actionable
 * browser noise patterns (e.g. cross-origin "Script error." or extension errors).
 */
export function isIgnoredErrorMessage(
  message: string | null | undefined,
): boolean {
  if (!message) {
    return false
  }

  const trimmed = message.trim()
  return IGNORED_ERROR_PATTERNS.some((pattern) => trimmed.includes(pattern))
}
